import { render, staticRenderFns } from "./SoftwarePartnerPage.vue?vue&type=template&id=9d304b82"
import script from "./SoftwarePartnerPage.vue?vue&type=script&lang=js"
export * from "./SoftwarePartnerPage.vue?vue&type=script&lang=js"
import style0 from "./SoftwarePartnerPage.vue?vue&type=style&index=0&id=9d304b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports